import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
var VueCookie = require('vue-cookie');
import router from './router'
import store from './store'
import axios from 'axios'
import VueToastr2 from 'vue-toastr-2'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'
import { httpClient } from './config/axios'
import JsonCSV from 'vue-json-csv'

Vue.prototype.$httpClient = httpClient

Vue.component('downloadCsv', JsonCSV)

import langMixin from './mixins/langMixin'
Vue.mixin(langMixin);

window.toastr = require('toastr')

Vue.use(VueToastr2)

Vue.config.productionTip = false
Vue.use(VueCookie);


import VueProgressBar from 'vue-progressbar'
const options = {
  color: '#168db3',
  failedColor: '#f44336',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}
Vue.use(VueProgressBar, options)

axios.defaults.headers.common['x-access-token'] = Vue.cookie.get('x-access-token')

// axios.interceptors.response.use(
// function(response) { return response },
// function(error) {
//   // if (error.response.status === 401) {
//   //   Vue.cookie.delete('x-access-token')
//   //   router.push('/')
//   // }
// })

router.beforeEach((to, from, next) => {
  if (
    to.matched.some(record => record.meta.requiresAuth) && router.app.$cookie.get('x-access-token') === null) {
      router.push('/')
  }  else {
    if (to.meta.requiresAdmin && router.app.$cookie.get('admin') == 0) {
        router.push('/tests')
      } else {
      next()
    }
  }
})

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
